// extracted by mini-css-extract-plugin
export var blue = "_2g-f";
export var brand = "_2g-b";
export var darkGrey = "_2g-e";
export var disabled = "_2g-4";
export var disabledSubtle = "_2g-5";
export var error = "_2g-6";
export var green = "_2g-g";
export var grey = "_2g-d";
export var icon = "_2g-0";
export var inherit = "_2g-a";
export var lightGrey = "_2g-c";
export var orange = "_2g-i";
export var pink = "_2g-k";
export var primary = "_2g-1";
export var purple = "_2g-l";
export var red = "_2g-j";
export var secondary = "_2g-2";
export var success = "_2g-9";
export var tertiary = "_2g-3";
export var warning = "_2g-7";
export var warningSecondary = "_2g-8";
export var white = "_2g-m";
export var yellow = "_2g-h";